import script from "./flightOriginDropDown.vue?vue&type=script&setup=true&lang=ts"
export * from "./flightOriginDropDown.vue?vue&type=script&setup=true&lang=ts"

import "./flightOriginDropDown.vue?vue&type=style&index=0&id=a5b32c8a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5b32c8a"]])

export default __exports__